import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { MEMBERSHIP_API } from 'modules/school/api/membership-api'
import type { CourseQuizId, CourseQuizResultInterface } from '../types/course-quiz-interface'

interface QuizAnswersPayload {
  courseQuizId: number
  data: boolean[][] | undefined
}

interface UseSendCourseQuizAnswersResult {
  sendCourseQuizAnswers: (payload: QuizAnswersPayload) => Promise<CourseQuizResultInterface>
  isFetching: boolean
}

export const useSendCourseQuizAnswers = (): UseSendCourseQuizAnswersResult => {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.postForm,
    CourseQuizResultInterface
  >({
    method: RequestMethodsEnum.postForm,
  })
  return {
    sendCourseQuizAnswers: async ({
      courseQuizId,
      data,
    }: {
      courseQuizId: CourseQuizId
      data: Array<Array<boolean>> | undefined
    }) => {
      const dataForBackend = data?.reduce(
        (resObj, arrayOfAnswer, questionIndex) => ({
          ...resObj,
          ...arrayOfAnswer.reduce(
            (resAnswersObj, isAnswerSelected, answerIndex) =>
              isAnswerSelected
                ? {
                    ...resAnswersObj,
                    [`questions[${questionIndex}][answers][${answerIndex}][selected]`]: '1',
                  }
                : resAnswersObj,
            {},
          ),
        }),
        {},
      )
      return await fetcher(`${MEMBERSHIP_API}/quiz/${courseQuizId}/vote`, dataForBackend)
    },
    isFetching,
  }
}
